export const PLACE_TYPES = ['clinic', 'home', 'telemed'] as const
